import { createAction } from "redux-actions";

// GET ALL MACHINE FEATURE MAPPING
export const GET_ALL_MACHINE_FEATURE = "GET_ALL_MACHINE_FEATURE";
export const getAllMachineFeatureMapping = createAction(
  GET_ALL_MACHINE_FEATURE
);

export const GET_ALL_MACHINE_FEATURE_SUCCESS =
  "GET_ALL_MACHINE_FEATURE_SUCCESS";
export const getAllMachineFeatureSuccess = createAction(
  GET_ALL_MACHINE_FEATURE_SUCCESS
);

export const GET_ALL_MACHINE_FEATURE_FAILURE =
  "GET_ALL_MACHINE_FEATURE_FAILURE";
export const getAllMachineFeatureFailure = createAction(
  GET_ALL_MACHINE_FEATURE_FAILURE
);

// GET ALL FEATURE LIST Along with Group
export const GET_ALL_FEATURES = "GET_ALL_FEATURES";
export const getAllFeatures = createAction(GET_ALL_FEATURES);

export const GET_ALL_FEATURES_SUCCESS = "GET_ALL_FEATURES_SUCCESS";
export const getAllFeaturesSuccess = createAction(GET_ALL_FEATURES_SUCCESS);

export const GET_ALL_FEATURES_FAILURE = "GET_ALL_FEATURES_FAILURE";
export const getAllFeaturesFailure = createAction(GET_ALL_FEATURES_FAILURE);

// UPLOAD VARIANT IMAGE
export const UPLOAD_VARIANT_IMAGE = "UPLOAD_VARIANT_IMAGE";
export const uploadVariantImage = createAction(UPLOAD_VARIANT_IMAGE);

export const UPLOAD_VARIANT_IMAGE_SUCCESS = "UPLOAD_VARIANT_IMAGE_SUCCESS";
export const uploadVariantImageSuccess = createAction(
  UPLOAD_VARIANT_IMAGE_SUCCESS
);

export const UPLOAD_VARIANT_IMAGE_FAILURE = "UPLOAD_VARIANT_IMAGE_FAILURE";
export const uploadVariantImageFailure = createAction(
  UPLOAD_VARIANT_IMAGE_FAILURE
);

// UPLOAD MODEL DOC
export const UPLOAD_MODEL_DOC = "UPLOAD_MODEL_DOC";
export const uploadModelDoc = createAction(UPLOAD_MODEL_DOC);

export const UPLOAD_MODEL_DOC_SUCCESS = "UPLOAD_MODEL_DOC_SUCCESS";
export const uploadModelDocSuccess = createAction(UPLOAD_MODEL_DOC_SUCCESS);

export const UPLOAD_MODEL_DOC_FAILURE = "UPLOAD_MODEL_DOC_FAILURE";
export const uploadModelDocFailure = createAction(UPLOAD_MODEL_DOC_FAILURE);

// ADD MACHINE VARIANT FEATURES
export const ADD_VARIANT_FEATURES = "ADD_VARIANT_FEATURES";
export const addVariantFeatures = createAction(ADD_VARIANT_FEATURES);

export const ADD_VARIANT_FEATURES_SUCCESS = "ADD_VARIANT_FEATURES_SUCCESS";
export const addVariantFeaturesSuccess = createAction(
  ADD_VARIANT_FEATURES_SUCCESS
);

export const ADD_VARIANT_FEATURES_FAILURE = "ADD_VARIANT_FEATURES_FAILURE";
export const addVariantFeaturesFailure = createAction(
  ADD_VARIANT_FEATURES_FAILURE
);

// UPDATE FEATURE DETAIL
export const UPDATE_FEATURE_DETAIL = "UPDATE_FEATURE_DETAIL";
export const updateFeatureDetail = createAction(UPDATE_FEATURE_DETAIL);

export const UPDATE_FEATURE_DETAIL_SUCCESS = "UPDATE_FEATURE_DETAIL_SUCCESS";
export const updateFeatureDetailSuccess = createAction(
  UPDATE_FEATURE_DETAIL_SUCCESS
);

export const UPDATE_FEATURE_DETAIL_FAILURE = "UPDATE_FEATURE_DETAIL_FAILURE";
export const updateFeatureDetailFailure = createAction(
  UPDATE_FEATURE_DETAIL_FAILURE
);

// DISABLE VARIANT FEATURE
export const DISABLE_VARIANT_FEATURE = "DISABLE_VARIANT_FEATURE";
export const disableVariantFeature = createAction(DISABLE_VARIANT_FEATURE);

export const DISABLE_VARIANT_FEATURE_SUCCESS =
  "DISABLE_VARIANT_FEATURE_SUCCESS";
export const disableVariantFeatureSuccess = createAction(
  DISABLE_VARIANT_FEATURE_SUCCESS
);

export const DISABLE_VARIANT_FEATURE_FAILURE =
  "DISABLE_VARIANT_FEATURE_FAILURE";
export const disableVariantFeatureFailure = createAction(
  DISABLE_VARIANT_FEATURE_FAILURE
);

// ENABLE VARIANT FEATURE
export const ENABLE_VARIANT_FEATURE = "ENABLE_VARIANT_FEATURE";
export const enableVariantFeature = createAction(ENABLE_VARIANT_FEATURE);

export const ENABLE_VARIANT_FEATURE_SUCCESS = "ENABLE_VARIANT_FEATURE_SUCCESS";
export const enableVariantFeatureSuccess = createAction(
  ENABLE_VARIANT_FEATURE_SUCCESS
);

export const ENABLE_VARIANT_FEATURE_FAILURE = "ENABLE_VARIANT_FEATURE_FAILURE";
export const enableVariantFeatureFailure = createAction(
  ENABLE_VARIANT_FEATURE_FAILURE
);
